import React from "react";
import { useHistory } from "react-router-dom";
import TableChartIcon from "@mui/icons-material/TableChart";
import ListIcon from '@mui/icons-material/List';

export const Container_List4 = ({ titulo, cards }) => {
    const history = useHistory();
    
    const selectedCardsReportes = [
        "RECUPERACION DE CARTERA",
        "PROYECCION DE RECUPERACION DE CARTERA",
        "RESUMEN CARTERA",
        "REPORTE COBRANZA",
        "REPORTE DE RECUPERACION DE CARTERA",
        "RESUMEN DE SALDOS DE CARTERA",
        "RECUPERACION DE CARTERA MENSUAL",
        "PEDIDOS FACTURADOS",
    ];

    const selectedCardsGestion = [
        "GESTIÓN DE COBRANZA",
        "BITÁCORA DE GESTIÓN DE COBRANZA",
        "BITÁCORA DE CONVENIOS REALIZADOS",
        "ESTADOS DE CUENTA"
    ];

    const selectedCardsAutomatizacion = [
        "PLANTILLAS KARBOT"
    ];

    const cardsReportes = cards.filter(card => 
        selectedCardsReportes.includes(card.titulo) 
    );

    const cardsGestion = cards.filter(card => 
        selectedCardsGestion.includes(card.titulo) 
    );

    const cardsAutomatizacion = cards.filter(card => 
        selectedCardsAutomatizacion.includes(card.titulo) 
    );

    return (
        <div className="container-boxes-list4">
            {/* Título principal de la pantalla */}
            <div className="container-boxes-list-titulo4">
                <div className="container-boxes-list-titulo-text4">MENU DE COBRANZA</div>
                <div className="container-boxes-list-titulo-efecto4">
                    <div className="container-boxes-list-titulo-efecto-bl4"></div>
                    <div className="container-boxes-list-titulo-efecto-circle4"></div>
                    <div className="container-boxes-list-titulo-efecto-br4"></div>
                </div>
            </div>

            {/* Contenedor que organiza los subtítulos en columnas */}
            <div className="container-boxes-columns">
                {/* Subtítulo 1 */}
                <div className="container-boxes-column">
                    <div className="container-boxes-list-subtitulo-text">
                        <ListIcon style={{ marginRight: "8px" }}/>
                        Reportes de Cobranza</div>
                    <div className="container-boxes-list-container">
                        {cardsReportes === undefined || cardsReportes === null || cardsReportes.length === 0 ? (
                            <div></div>
                        ) : (
                            cardsReportes.map((card) => (
                                <div
                                    className="container-boxes-list-container-card"
                                    onClick={() => history.push(card.ruta)}
                                >
                                    <TableChartIcon /> {card.titulo}
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* Subtítulo 2 */}
                <div className="container-boxes-column">
                    <div className="container-boxes-list-subtitulo-text">
                        <ListIcon style={{ marginRight: "8px" }}/>
                        Gestión de Cobranza</div>
                    <div className="container-boxes-list-container">
                    {cardsGestion === undefined || cardsGestion === null || cardsGestion.length === 0 ? (
                            <div></div>
                        ) : (
                            cardsGestion.map((card) => (
                                <div
                                    className="container-boxes-list-container-card"
                                    onClick={() => history.push(card.ruta)}
                                >
                                    <TableChartIcon /> {card.titulo}
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <div className="container-boxes-column">
                    <div className="container-boxes-list-subtitulo-text">
                        <ListIcon style={{ marginRight: "8px" }}/>
                        Automatización de Mensajes</div>
                    <div className="container-boxes-list-container">
                    {cardsAutomatizacion === undefined || cardsAutomatizacion === null || cardsAutomatizacion.length === 0 ? (
                            <div></div>
                        ) : (
                            cardsAutomatizacion.map((card) => (
                                <div
                                    className="container-boxes-list-container-card"
                                    onClick={() => history.push(card.ruta)}
                                >
                                    <TableChartIcon /> {card.titulo}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
};
